import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import backgroundpic from '../assets/img/bluebackgroundjpg.jpg';
import Swal from 'sweetalert2';
import { API_URL } from "./config";

const PosSplash = () => {
  const [loading, setLoading] = useState(true);
  const [userDetails, setUserDetails] = useState({});
  const [companyBranchDetails, setCompanyBranchDetails] = useState(null);
  const [shiftOpen, setShiftOpen] = useState(false);
  const [openShiftDetails, setOpenShiftDetails] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompanyBranchDetails = async () => {
      const companyId = localStorage.getItem('company_id');
      const branchId = localStorage.getItem('branch_id');
      const operatorId = localStorage.getItem('user_id');

      if (!companyId || !branchId) {
        console.log('Company ID or Branch ID not found in local storage.');
        setLoading(false);
        return;
      }

      const url = `${API_URL}/companysetup/getFullCompanyBranchDetails/${companyId}/${branchId}`;

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        const details = data[0];

        // Store company and branch details in local storage
        localStorage.setItem('companyName', details.company_name);
        localStorage.setItem('branchName', details.branch_name);
        localStorage.setItem('branchLocation', details.branch_location);
        localStorage.setItem('email', details.email);
        localStorage.setItem('phone', details.phone);
        localStorage.setItem('registrationNumber', details.registration_number);
        localStorage.setItem('vatNumber', details.vat_number);

        setCompanyBranchDetails(details);
        fetchOpenShift(companyId, branchId, operatorId);
      } catch (error) {
        console.error('Error fetching company branch details:', error);
        setLoading(false); // Set loading to false on error
      }
    };

    const fetchOpenShift = async (companyId, branchId, operatorId) => {
      const shiftStatus = 'open';
      const url = `${API_URL}/shift/getShiftByCompanyBranchOperatorStatus/${companyId}/${branchId}/${operatorId}/${shiftStatus}`;

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();

        if (data && data.length > 0) {
          setShiftOpen(true);
          setOpenShiftDetails(data[0]);
        } else {
          setShiftOpen(false);
          navigate('/openShift');
        }
      } catch (error) {
        console.error('Error fetching open shift:', error);
        setLoading(false); // Set loading to false on error
        navigate('/openShift');
      }
    };

    const checkShiftDetails = () => {
      const shiftDetails = localStorage.getItem('shiftDetails');

      const userDetailsKeys = [
        'user_id',
        'userName',
        'async_client_profile_id',
        'async_role',
        'async_category',
        'async_username',
        'branch_id',
        'company_id',
      ];

      const retrievedDetails = {};
      userDetailsKeys.forEach(key => {
        retrievedDetails[key] = localStorage.getItem(key);
      });

      setUserDetails(retrievedDetails);
    };

    const logLocalStorage = () => {
      console.log('Local Storage Items:');
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        const value = localStorage.getItem(key);
        console.log(`${key}: ${value}`);
      }
    };

    const timer = setTimeout(() => {
      checkShiftDetails();
      fetchCompanyBranchDetails();
      logLocalStorage(); // Log items in local storage
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  useEffect(() => {
    if (shiftOpen && openShiftDetails) {
      // Storing shift details in local storage
      const shiftDetails = {
        shift_id: openShiftDetails.shift_id,
        company_id: openShiftDetails.company_id,
        branch_id: openShiftDetails.branch_id,
        operator_id: openShiftDetails.operator_id,
        date_time_open: openShiftDetails.date_time_open,
        shift_comment: openShiftDetails.shift_comment,
      };

      localStorage.setItem('shiftDetails', JSON.stringify(shiftDetails));

      console.log('Shift Details stored in local storage:', shiftDetails);

      Swal.fire({
        title: 'Open Shift Found!',
        text: `An open shift for ${userDetails.userName}. Do you want to continue?`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/pos', {
            state: { 
              shiftDetails: openShiftDetails,
              userDetails,
              companyBranchDetails,
            }
          });
        } else {
          navigate('/MainMenu');
        }
      });
    }
  }, [shiftOpen, openShiftDetails, userDetails.userName, navigate]);

  return (
    <div style={{
      backgroundImage: `url(${backgroundpic})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      color: '#ffffff',
      flexDirection: 'column',
    }}>
      <h1>Welcome to REMS Point Of Sale</h1>
      {loading && <div className="spinner-border" role="status" style={{ marginTop: '20px' }}><span className="visually-hidden">Loading...</span></div>}
      {!loading && (
        <div>
          <p>User ID: {userDetails.user_id}</p>
          <p>Username: {userDetails.userName}</p>
          <p>Client Profile ID: {userDetails.async_client_profile_id}</p>
          <p>Role: {userDetails.async_role}</p>
          <p>Category: {userDetails.async_category}</p>
          <p>Email: {userDetails.async_username}</p>
          <p>Branch ID: {userDetails.branch_id}</p>
          <p>Company ID: {userDetails.company_id}</p>
          {companyBranchDetails && (
            <div>
              <h2>Company and Branch Details</h2>
              <p>Company Name: {companyBranchDetails.company_name}</p>
              <p>Branch Name: {companyBranchDetails.branch_name}</p>
              <p>Branch Location: {companyBranchDetails.branch_location}</p>
              <p>Email: {companyBranchDetails.email}</p>
              <p>Phone: {companyBranchDetails.phone}</p>
              <p>Registration Number: {companyBranchDetails.registration_number}</p>
              <p>VAT Number: {companyBranchDetails.vat_number}</p>
            </div>
          )}
          {shiftOpen ? (
            <p style={{ color: 'green' }}>An open shift is available.</p>
          ) : (
            <p style={{ color: 'red' }}>No open shift found.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default PosSplash;